import React, { useEffect, useState, useReducer } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { parseInt, reverse, sortBy } from "lodash";
import { useSelector } from "react-redux";

import { getTheme } from "../../../common/highChartTheme";

import ophReducer from "../../../../reducers/oph";
import * as action from "../../../../actions/oph";

const initialData = {
  ophMissReasonGraph: [],
};

const UnitMissedGraph = (props) => {
  const isLightMode = useSelector((state) => state.theme.lightMode);
  const { refreshData } = useSelector((state) => state.ophDataRefresh);

  const { tierId, startDate, endDate, rowcount, reasonLevel, isCascaded } =
    props;

  const [graphData, setGraphData] = useState([]);

  const [state, dispatch] = useReducer(ophReducer, initialData);

  const { ophMissReasonGraph } = state;

  useEffect(() => {
    action.fetchOphMissReasonGraphData(dispatch, {
      tier: tierId,
      startDate,
      endDate,
      rowcount,
      type: "missedQty",
      reasonLevel,
      isCascaded,
    });
  }, [refreshData, startDate, endDate, rowcount, reasonLevel, isCascaded]);

  useEffect(() => {
    if (ophMissReasonGraph) {
      setGraphData(reverse(sortBy(ophMissReasonGraph, ["missedQty"])));
    }
  }, [ophMissReasonGraph]);

  const getGraphOptions = () => {
    const options = {
      chart: {
        type: "column",
      },
      tooltip: {
        shared: true,
      },
      series: [
        {
          showInLegend: false,
          name: "",
          type: "column",
          colorByPoint: true,
          size: "100%",
          colors: graphData?.map((x) => {
            return x.reasonColorCode;
          }),
          data: graphData?.map((x) => {
            return [x.reasonCode, parseInt(x.missedQty)];
          }),
        },
      ],
    };
    return options;
  };

  return (
    <div
      style={{
        backgroundColor: isLightMode ? "#d3d3d3" : "#2a2a2a",
        padding: "20px 0px",
      }}
    >
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          ...getGraphOptions(),
          ...getTheme(
            "OPH Unit Missed",
            isLightMode,
            graphData?.map((x) => x.reasonCode)
          ),
        }}
      />
    </div>
  );
};

export default React.memo(UnitMissedGraph);
